import * as CodeMirror from 'codemirror';

function beforeChange(cm: CodeMirror.Editor, event: any): void {
  const hasTypedNewline = event.origin === '+input' && typeof event.text === 'object' && event.text.join('') === '';

  if (hasTypedNewline) {
    return event.cancel();
  }

  const hasPastedNewline = event.origin === 'paste' && typeof event.text === 'object' && event.text.length > 1;

  if (hasPastedNewline) {
    return event.update(null, null, [event.text.join(' ')]);
  }
}

CodeMirror.defineOption('noNewlines', false, (cm: CodeMirror.Editor, val: boolean, old: boolean) => {
  if (val === true && old !== true) {
    cm.on('beforeChange', beforeChange);
  } else if (val === false && old === true) {
    cm.off('beforeChange', beforeChange);
  }
});
